import axios, { InternalAxiosRequestConfig } from "axios";
import { triggerLogout } from "./authLogout";

const requestInterceptor = (config: InternalAxiosRequestConfig) => {
  config.headers.set("Aurora-Time-Zone", localStorage.getItem("auroraTimeZone") || "UTC");
  return config;
};

const responseErrorInterceptor = (error: unknown) => {
  if (axios.isAxiosError(error) && error.response?.status === 401 && error.response?.data?.message === "token has been revoked") {
    triggerLogout();
  }
  return Promise.reject(error);
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});
api.interceptors.request.use(requestInterceptor);
api.interceptors.response.use(undefined, responseErrorInterceptor);

export const apiV2 = axios.create({
  baseURL: process.env.REACT_APP_API_V2_URL,
  headers: { "Content-Type": "application/json" },
});
apiV2.interceptors.request.use(requestInterceptor);
apiV2.interceptors.response.use(undefined, responseErrorInterceptor);


export const massWarningAPI = axios.create({
  baseURL: process.env.REACT_APP_MASS_WARNING_API,
  headers: {
    "Content-Type": "application/json",
  },
})

import { platformAPIErrorInterceptor } from "./APIError";

export const platformAPI = axios.create({
  baseURL: process.env.REACT_APP_PLATFORM_API,
  headers: {
    "Content-Type": "application/json",
  },
});

platformAPI.interceptors.request.use(requestInterceptor);
platformAPI.interceptors.response.use(undefined, platformAPIErrorInterceptor);

export const platformFormAPI = axios.create({
  baseURL: process.env.REACT_APP_PLATFORM_API,
});

platformFormAPI.interceptors.request.use(requestInterceptor)

export default api;
